<template>
  <div>
    <h1 class="page-header">{{ $t('disciplinaryActivity.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @success_create="fetchData" :edit="edit_data" @success_update="edit_data = ''"
              @cancel="fetchData"></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"></div>
              <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
                <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" class="kh-font" />
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table :columns="columns" :records="resources" :loading="loading">
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{ record.dis_activity_kh }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.dis_activity_en }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.letter_type }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.penalties ? record.penalties.penalty_type_en : '' }}
                </td>
                <td class="text-center">
                  <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
                    <i class="fas fa-edit"></i>
                  </a>
                  <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record.dis_activity_id)">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
export default {
  components: {
    FormCreate
  },
  name: 'activity',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: this.$t('disciplinaryActivity.nameKH') },
        { name: this.$t('disciplinaryActivity.nameEn') },
        {
          name: this.$t('disciplinaryActivity.letterType'),
        },
        {
          name: this.$t('disciplinaryActivity.penaltyType'),
        },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('disciplinaryActivity', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.disciplinaryActivity.search
      },
      set(newVal) {
        this.$store.commit('disciplinaryActivity/SET_SEARCH', newVal)
        this.$store.commit('disciplinaryActivity/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('disciplinaryActivity/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/disciplinary-activities/${data.dis_activity_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('disciplinaryActivity/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'disciplinary-activity-create') {
      this.$store.commit('disciplinaryActivity/RESET_STATE')
    }
    next()
  }
}
</script>
